const SCREEN = {
  STATEMENTS_HISTORY: 'Statements History',
  STATEMENTS: 'Statements',
  AUTO_DEBIT_DETAILS: 'Auto Debit Details',
};

const ACTION = {
  CLICK: 'Click',
  PAGE_VIEW: 'Page View',
};

const ITEM = {
  SETTLE: 'Settle',
  AUTO_DEBIT_DETAILS: 'Auto Debit Details',
};

export { ACTION, ITEM, SCREEN };
